<script>
export default {
  name: "loading-component",
}
</script>

<template>
  <div class="loading">
    <span class="loader"></span>
  </div>
</template>

<style scoped>

</style>